import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 lg:py-28 bg-gradient-to-br from-primary via-accent to-primary">
      <div className="mx-auto px-4 md:px-6 lg:px-24 max-w-5xl">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-white/20 rounded-full mb-5 md:mb-6">
            <Icon name="TrendingUp" size={36} color="white" strokeWidth={2} />
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-white mb-4 md:mb-5">
            Take Control of Your Money Today
          </h2>

          <p className="text-base md:text-lg lg:text-xl text-white/95 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
            Join thousands who've found clarity, confidence, and simplicity with Rovyn Budget. Start free and experience the difference.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 md:mb-10">
            <Button
              variant="secondary"
              size="xl"
              onClick={() => navigate('/register')}
              iconName="ArrowRight"
              iconPosition="right"
              className="min-h-[56px] md:min-h-[60px] px-8 md:px-10 bg-white text-primary hover:bg-white/95 font-semibold text-base md:text-lg"
            >
              Start Free Now
            </Button>
            <Button
              variant="outline"
              size="xl"
              onClick={() => navigate('/login')}
              iconName="LogIn"
              iconPosition="left"
              className="min-h-[56px] md:min-h-[60px] px-8 md:px-10 border-2 border-white text-white hover:bg-white/10 font-semibold text-base md:text-lg"
            >
              Sign In
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-5 md:gap-8 text-white/95">
            <div className="flex items-center gap-2">
              <Icon name="Check" size={20} color="white" strokeWidth={3} />
              <span className="text-sm md:text-base font-caption">No credit card required</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Check" size={20} color="white" strokeWidth={3} />
              <span className="text-sm md:text-base font-caption">Free forever plan</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Check" size={20} color="white" strokeWidth={3} />
              <span className="text-sm md:text-base font-caption">Cancel anytime</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;